var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('a',{staticStyle:{"text-decoration":"none","cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.detailFun.apply(null, arguments)}}},[_vm._v(_vm._s(this.data.operateTitle))]),_c('span',{staticStyle:{"margin-left":"15px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }